import {
  GET_ROUTES_EXPORT_FORMATS,
  GET_ROUTES_EXPORT_FORMATS_SUCCESS,
  GET_ROUTES_EXPORT_FORMATS_ERROR,
} from 'constants/ActionTypes';

const INITIAL_STATE = {
  routesExportFormats: [],
  isLoadingFormats: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ROUTES_EXPORT_FORMATS:
      return {
        ...state,
        isLoadingFormats: true,
      };
    case GET_ROUTES_EXPORT_FORMATS_SUCCESS:
      return {
        ...state,
        routesExportFormats: action.payload,
        isLoadingFormats: false,
      };
    case GET_ROUTES_EXPORT_FORMATS_ERROR:
      return {
        ...state,
        isLoadingFormats: false,
      };
    default:
      return state;
  }
};
